import React from "react";
import PageHeader from "../components/PageHeader";

const Terms = () => {
  return (
    <div className="bg-dreibach-black min-h-screen pb-24">
      <PageHeader 
        title="Terms of Service" 
        subtitle="Last Updated: January 2026"
        image="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=2000"
      />
      <div className="container mx-auto px-6 py-24 max-w-4xl text-gray-300 space-y-8">
        <h3 className="text-xl font-bold text-white">1. Acceptance of Terms</h3>
        <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
        <h3 className="text-xl font-bold text-white">2. Use of License</h3>
        <p>Permission is granted to temporarily download one copy of the materials (information or software) on Dreibach Ltd's website for personal, non-commercial transitory viewing only.</p>
        <h3 className="text-xl font-bold text-white">3. Disclaimer</h3>
        <p>The materials on Dreibach Ltd's website are provided "as is". Dreibach Ltd makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties.</p>
      </div>
    </div>
  );
};

export default Terms;
